// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorStores = (client) => ({
    /**
     * `GET /vendor/stores`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListStores
     * @source packages/modules/b2c-core/src/api/vendor/stores/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/stores", { method: "GET", query, headers }),
    /**
     * `GET /vendor/stores/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetStoreById
     * @source packages/modules/b2c-core/src/api/vendor/stores/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/stores/:id", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=stores.js.map